
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 51.913h50m-41.3 0v-6.522H4.178v6.522m19.565.002V36.698h-6.521v15.217m19.565-.005V27.999h-6.522V51.91m19.565.003V19.304h-6.52v32.609M7.439 30.176L46.571 4.088m-1.093 8.695l1.087-8.696L37.87 3","fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    